<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/text';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-spectrum/text/package.json';

```jsx import
import {Heading} from '@react-spectrum/text';
```

---
category: Content
---

# Heading

<p>{docs.exports.Heading.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Heading']}
  sourceData={[]} />

## Example

```tsx example
<Heading level={4}>Edit</Heading>
```

## Content

Heading is a Text component which is a child to other components. Heading provides
style information, like a title within a Dialog, based on placement
within a parent component. Based on the component Heading is used within, it
gets Spectrum styling and may have a preassigned slot for positioning. By
virtue of its name, the Heading component provides semantic meaning in the
context they are placed. Examples of their usage in [Dialog](Dialog.html#example) and
[IllustratedMessage](IllustratedMessage.html#example). It is important to note
that the Heading component accepts any renderable node, not just strings.

## Props

<PropTable component={docs.exports.Heading} links={docs.links} />
